import { validateDateRange } from "../../utils";

export const projectValidationRules = (values) => {
  const errors = {};

  // project fields
  if (!values.name) errors.name = "Project name is required";
  else if (values.name.length < 3) errors.name = "Project name must be at least 3 characters";
  if (!values.clientId || isNaN(values.clientId)) errors.clientId = "Please select a client";
  if (!values.type) errors.type = "Project type is required";
  if (values.estimatedAmount && values.estimatedAmount <= 0) errors.estimatedAmount = "Estimated amount must be greater than 0";
  if (values.description && values.description.length < 5) errors.description = "Description must be at least 5 characters";

  // project dates
  if (!values.expectedStartDate) errors.expectedStartDate = "Please select expected start date";
  if (!values.expectedEndDate) errors.expectedEndDate = "Please select expected end date";

  const projectDateErrors = validateDateRange({
    fieldName: "expectedEndDate",
    startDateKey: "expectedStartDate",
    endDateKey: "expectedEndDate",
    startDate: values.expectedStartDate,
    endDate: values.expectedEndDate,
  });

  if (projectDateErrors.expectedStartDate) errors.expectedStartDate = projectDateErrors.expectedStartDate;
  if (projectDateErrors.expectedEndDate) errors.expectedEndDate = projectDateErrors.expectedEndDate;

  // government project tender fields
  if (values.isGovernment && values.tender) {
    const tenderErrors = {};

    if (!values.tender.agreementDate) tenderErrors.agreementDate = "Please select tender agreement date";
    if (!values.tender.siteHandoverDate) tenderErrors.siteHandoverDate = "Please select site handover date";
    if (!values.tender.agreementDuration) tenderErrors.agreementDuration = "Please enter agreement duration";

    const tenderDateErrors = validateDateRange({
      fieldName: "siteHandoverDate",
      startDateKey: "agreementDate",
      endDateKey: "siteHandoverDate",
      startDate: values.tender.agreementDate,
      endDate: values.tender.siteHandoverDate,
      startErrorText: "Agreement date cannot be after site handover date",
      endErrorText: "Site handover date cannot be before agreement date",
    });

    if (tenderDateErrors.agreementDate) tenderErrors.agreementDate = tenderDateErrors.agreementDate;
    if (tenderDateErrors.siteHandoverDate) tenderErrors.siteHandoverDate = tenderDateErrors.siteHandoverDate;

    if (Object.keys(tenderErrors).length > 0) {
      errors.tender = tenderErrors;
    }
  }

  return errors;
};

export const projectStageValidationRules = (values) => {
  const errors = {};

  if (!values.stageId) errors.stageId = "Please select a stage";
  if (!values.estimatedAmount) errors.estimatedAmount = "Please enter estimated amount";
  else if (isNaN(values.estimatedAmount)) errors.estimatedAmount = "Estimated amount must be a number";
  else if (Number(values.estimatedAmount) < 0) errors.estimatedAmount = "Estimated amount must be greater than 0";

  return errors;
};

export const moveToolValidationRules = (values) => {
  const errors = {};

  if (!values.toolId) errors.toolId = "Please select a tool";
  if (!values.fromStoreId) errors.fromStoreId = "Please select project/company store";
  if (!values.movedQuantity) errors.movedQuantity = "Please enter quantity";

  return errors;
};
